__turbopack_context__.v({
  "product-card": "AcfProductComparisonCard-module-scss-module__i2mvCW__product-card",
  "product-card-button": "AcfProductComparisonCard-module-scss-module__i2mvCW__product-card-button",
  "product-card-cta-container": "AcfProductComparisonCard-module-scss-module__i2mvCW__product-card-cta-container",
  "product-card-eyebrow": "AcfProductComparisonCard-module-scss-module__i2mvCW__product-card-eyebrow",
  "product-card-foot": "AcfProductComparisonCard-module-scss-module__i2mvCW__product-card-foot",
  "product-card-price": "AcfProductComparisonCard-module-scss-module__i2mvCW__product-card-price",
  "product-card-title-chip": "AcfProductComparisonCard-module-scss-module__i2mvCW__product-card-title-chip",
  "product-card-title-container": "AcfProductComparisonCard-module-scss-module__i2mvCW__product-card-title-container",
});
